import { isRecallRequestRowValid } from "src/utils/validators";

export const RecallSelectors = {
    RecallRequestComment: (state) => state.Recall.requestComment,
    RecallRequestRows: (state) => state.Recall.requestRows,
    RecallRawEntriesForLender: (state) => state.Recall.lenderRecallEntries,
    RecallRawEntriesForBorrower: (state) => state.Recall.borrowerRecallEntries,
    IsRecallRequestValid: (state) => {
        if (state.Recall.requestRows.length === 0) return false;

        return state.Recall.requestRows.reduce(
            (isValid, row) => isValid && isRecallRequestRowValid(row),
            true
        );
    },
    HasRecallsListUpdate: (state) => state.Recall.hasUpdate,
};
